/**
 * @param momentRange
 * @constructor
 */
function PeriodCalculator(momentRange) {
    this.momentRange = momentRange;
}

/**
 * Calculates the period based on an hourly interval
 * @returns {number}
 */
PeriodCalculator.prototype.hours = function() {
    // Figure out the number of hours. We can do this by calculating the number of minutes in the duration,
    // dividing 60 to get the number of hours
    var range = this.momentRange,
        numMinutes = range.diff('minutes');

    return numMinutes / 60;
};

/**
 * Calculates the period based on a nightly interval
 * @returns {number}
 */
PeriodCalculator.prototype.nights = function() {
    // Figure out the number of nights. We can do this by calculating the number of hours in the duration,
    // dividing 24 to get the number of full days, then taking the modulus of 24 for the remaining hours and
    // checking that it is greater than the number of hours left in the day.
    var range = this.momentRange,
        numMinutes = range.diff('minutes'),
        numNights = Math.floor(numMinutes / 1440),
        remainingMinutes = numMinutes % 1440,
        minutesLeftInFirstDay = 1440 - (range.start.hour() * 60 + range.start.minute()),
        dstMinuteCount = 1380;

    if(remainingMinutes >= minutesLeftInFirstDay) {
        numNights++;
    }else {
        // check for daylight savings start - remaining minutes will be 1380
        if(remainingMinutes === dstMinuteCount){
            numNights++;
        }
    }

    return numNights;
};

/**
 * Calculates the period based on a daily interval
 * @returns {number}
 */
PeriodCalculator.prototype.days = function() {
    // Just get the number of nights and add one
    return this.nights() + 1;
};

/**
 * Return the proportion of weeks the range covers
 *
 * @returns {number}
 */
PeriodCalculator.prototype.weeks = function() {
    // Just the number of nights divided by 7
    return this.nights() / 7;
};

/**
 * Return the proportion of months the range covers
 *
 * @returns {number}
 */
PeriodCalculator.prototype.months = function() {
    // Unfortunately, the days in the booking will need to be looped.
    var daysInMonths = {}, daysInMonth, numMonths = 0;
    // Loop the days in build up an array of how many days in each different type of month length.
    this.momentRange.by('day', function(day) {
        daysInMonth = day.daysInMonth();
        if(!daysInMonths.hasOwnProperty(daysInMonth)) {
            daysInMonths[daysInMonth] = 0;
        }
        daysInMonths[daysInMonth]++;
    }, true);
    // Now for each of the counts of days in the months in the range, we need to add the dividend of the month
    for(daysInMonth in daysInMonths) {
        if(daysInMonths.hasOwnProperty(daysInMonth)) {
            numMonths += daysInMonths[daysInMonth] / daysInMonth;
        }
    }
    return numMonths;
};

/**
 * Return the proportion of quarters the range covers
 *
 * @returns {number}
 */
PeriodCalculator.prototype.quarters = function() {
    return this.months() / 3;
};

/**
 * Return the proportion of years the range covers
 *
 * @returns {number}
 */
PeriodCalculator.prototype.years = function() {
    if (!this.momentRange.start || !this.momentRange.end) {
        return false;
    }

    // Get the first and last years in the range
    var firstYear = parseInt(this.momentRange.start.format('YYYY')),
        lastYear = parseInt(this.momentRange.end.format('YYYY')),
        // Then count the number of years spanned
        numYears = lastYear - firstYear,
        // Set a variable to hold the number of years that include a leap year and a variable for the following loop
        yearsWithLeapDate = 0, year;

    // Loop the years in the booking to check if the period includes a leap date
    for(year = firstYear; year <= lastYear; year++) {
        // We can immediately continue if this year is not a leap year
        if(!moment([year]).isLeapYear()) {
            continue;
        }
        // Otherwise check if the leap date is in the range
        if(this.momentRange.contains(moment(year + '-02-29'))) {
            yearsWithLeapDate++;
        }
    }

    // Now make sure that the number of years is at least one
    if(numYears === 0) {
        numYears = 1;
    }

    // And now return the number of nights divided by the number of days in a normal year PLUS the fraction of years
    // that contain the extra day.
    return this.nights() / (365 + (yearsWithLeapDate / numYears));
};

PeriodCalculator.prototype.getPeriodLabel = function(periodType) {
    var numPeriods = this.period(periodType),
        labels = PeriodCalculator.getPeriodDefinition(periodType);

    if(numPeriods === 1) {
        return labels.singular;
    }
    else {
        return labels.plural;
    }
};

/**
 * Adjusts the range to the given number of given periods from the start date
 *
 * @param periods
 * @param periodType
 * @returns {PeriodCalculator}
 */
PeriodCalculator.prototype.adjust = function(periods, periodType) {
    if (!this.momentRange.start || !this.momentRange.end) {
        return false;
    }

    // Create a copy of the start date to serve as our base.
    var newEnd = this.momentRange.start.clone();

    // Set the time to replicate the existing end.
    newEnd.hour(this.momentRange.end.hour()).minute(this.momentRange.end.minute());

    switch(PeriodCalculator.resolvePeriod(periodType)) {
        case 2:
            periods--;
        case undefined:
        case 1:
        default:
            this.momentRange.end = newEnd.add(periods, 'days');
            break;
        case 4:
            this.momentRange.end = newEnd.add(Math.round(periods * 7), 'days');
            break;
        case 5:
            var periodsAdded = 0, periodAdded;
            while(periodsAdded < periods) {
                periodAdded = 1 / newEnd.daysInMonth();
                periodsAdded += periodAdded;
                newEnd.add(1, 'day');
            }

            if((periodsAdded - (periodsAdded / 2)) > periods) {
                this.momentRange.end = newEnd;
            }
            else {
                this.momentRange.end = newEnd.subtract(1, 'day');
            }
            break;
        case 6:
            // Can't adjust based on fixed, we'll just keep it the same but we'll throw a warning
            console.warn('Attempted to adjust a period using a fixed period type');
            break;
        case 7:
            this.adjust(periods * 3, 5);
            break;
        case 8:
            var periodsLeft = periods;
            while (periodsLeft >= 1) {
                newEnd.add(1, 'year');
                periodsLeft--;
            }
            // All we should have left is zero, or a fraction
            if(periodsLeft > 0) {
                newEnd.add(Math.round(periodsLeft * (newEnd.isLeapYear() ? 366 : 365)), 'days');
            }
            this.momentRange.end = newEnd;
            break;
        case 10:
            // Re-adjust the end date if it a time base period
            newEnd = this.momentRange.start.clone();
            newEnd.add(periods, 'hours');
            this.momentRange.end = newEnd;
            break;
    }

    return this;
};

/**
 * Guess which period this range is best represented by.
 *
 * For instance:
 *  > 1 Oct - 1 Jan  -- Quarters (7)
 *  > 1 Jan - 1 Jan  -- Years (8)
 *  > 1 Oct - 1 Nov  -- Months (5)
 *  > 1 Oct - 12 Nov -- Weeks (4)
 *  > Others         -- Days (2)
 */
PeriodCalculator.prototype.guessPeriodType = function()
{
    var floored, acceptable = function(num, ratio) {
        // It's acceptable if the number is whole
        floored = Math.floor(num);
        if (floored === num) {
            return true;
        }
        // Otherwise calculate within confidence
        num = num - floored;
        return (num + (1 / ratio)) >= 1;
    }, clone;

    // Just return the lowest denominator if the period is zero.
    if (this.nights() === 0) {
        return 2;
    }

    // Start with yearly
    if (acceptable(this.years(), 365)) {
        return 8;
    }
    if (acceptable(this.quarters(), (365 / 4))) {
        return 7
    }

    // For monthly, we'll just check if adding a day will help...
    clone = this.clone();
    clone.momentRange.end.add('1', 'day');
    if (acceptable(this.months()) || acceptable(clone.months())) {
        return 5;
    }

    // We will make one day slip in a 4 week period the tolerance.
    if (acceptable(this.weeks(), 28)) {
        return 4;
    }

    return 2;
};

/**
 * Get the number of the given periods in the range
 *
 * @param periodType
 * @returns number
 */
PeriodCalculator.prototype.period = function(periodType) {
    // Now switch the logic depending on the period type
    switch(PeriodCalculator.resolvePeriod(periodType)) {
        // Default the period type to "nights"
        case 1:
        default:
            return this.nights();
        case 2:
            return this.days();
        case 4:
            return this.weeks();
        case 5:
            return this.months();
        case 6: // Fixed
            return 1;
        case 7:
            return this.quarters();
        case 8:
            return this.years();
        case 10:
            return this.hours();
    }
};

/**
 * Clones this period calculator object
 *
 * @returns {PeriodCalculator}
 */
PeriodCalculator.prototype.clone = function()
{
    return new PeriodCalculator(this.momentRange.clone());
};

/**
 * Given a parameter which can be used to refer to a period iBex supports, attempts to resolve the given value to the
 * corresponding numeric constant for the period
 *
 * @param periodType
 * @returns {number}
 * @static
 */
PeriodCalculator.resolvePeriod = function(periodType) {
    // Now switch the logic depending on the period type
    //noinspection FallThroughInSwitchStatementJS
    switch(periodType) {
        // Default the period type to "nights"
        default:
            console.warn('Unknown period given: ', periodType);
        case 'night':
        case 'nights':
        case 'nightly':
        case 1:
            return 1;
        case 'day':
        case 'days':
        case 'daily':
        case 2:
            return 2;
        case 'week':
        case 'weeks':
        case 'weekly':
        case 4:
            return 4;
        case 'month':
        case 'months':
        case 'monthly':
        case 5:
            return 5;
        case 'fixed':
        case 6:
            return 6;
        case 'quarter':
        case 'quarters':
        case 'quarterly':
        case 7:
            return 7;
        case 'year':
        case 'years':
        case 'yearly':
        case 8:
            return 8;
        case 'hour':
        case 'hours':
        case 'hourly':
        case 10:
            return 10;
    }
};

/**
 * Given a parameter which can be used to refer to a period iBex supports, provides an object which contains some
 * strings used for displaying the period type
 *
 * @param periodType
 * @returns {object}
 * @static
 */
PeriodCalculator.getPeriodDefinition = function(periodType) {
    switch(this.resolvePeriod(periodType)) {
        case 1:
            return {
                singular: 'Night',
                plural: 'Nights',
                adverb: 'Nightly'
            };
        case 2:
            return {
                singular: 'Day',
                plural: 'Days',
                adverb: 'Daily'
            };
        case 4:
            return {
                singular: 'Week',
                plural: 'Weeks',
                adverb: 'Weekly'
            };
        case 5:
            return {
                singular: 'Month',
                plural: 'Months',
                adverb: 'Monthly'
            };
        case 6:
            return {
                singular: 'Fixed',
                plural: 'Fixed',
                adverb: 'Fixed'
            };
        case 7:
            return {
                singular: 'Quarter',
                plural: 'Quarters',
                adverb: 'Quarterly'
            };
        case 8:
            return {
                singular: 'Year',
                plural: 'Years',
                adverb: 'Yearly'
            };
        case 10:
            return {
                singular: 'Hour',
                plural: 'Hours',
                adverb: 'Hourly'
            };
    }
};

// Attempt to add as a plugin to moment range
if(typeof moment.range.constructor === 'function') {
    moment.range.constructor.prototype.periods = function() {
        return new PeriodCalculator(this);
    }
}